import { initializeApp } from "firebase/app";

import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyArX0RctkoZu-WRqL6-Mo5-DofVN9iWDHk",
  authDomain: "loom-hackathon.firebaseapp.com",
  projectId: "loom-hackathon",
  storageBucket: "loom-hackathon.appspot.com",
  messagingSenderId: "309171179260",
  appId: "1:309171179260:web:107e9fdfb7d560f0429179",
};

let firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
if (process.env.NODE_ENV === "development") {
  connectAuthEmulator(auth, "http://192.168.86.2:9099");
}

//auth.useEmulator('http://localhost:9099/');

export default firebaseApp;
